const defaultPieChartColors = [
    '#e31837',
    '#FFC72C',
    '#808080',
    '#00558C',
    '#5F8F3D',
    '#006BD6',
]

export const clientThemeShell = {
    mainLayout: {
        backgroundColor: '#f4f4f5',
        hover: {
            backgroundColor: '#e31837',
        },
    },
    topBar: {
        backgroundColor: '',
        contrastText: '',
        contrastLinkText: '#00aeef',
        userIcon: '#FF3B29',
        brandLogo: {
            maxWidth: '150px',
            paddingTop: '0px',
        },
        menuBarIcon: {
            color: '#a1a1aa',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#121315',
        darkBackgroundColor: '#27272a',
        sideMenuActive: {
            backgroundColor: '#e31837',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#e31837',
        stroke: '#e31837',
        lineCharts: {
            stroke: '#e31837',
            fill: '#e31837',
        },
        areaCharts: {
            gradient: {
                start: '#e31837',
                stop: '#e31837',
            },
            stroke: '#e31837',
            fill: '#e31837',
            chargebacksByPostDateChart: {
                stroke: '#e31837',
                fill: '#e31837',
            },
            newAlertsByDateChart: [
                {
                    stroke: '#FFC72C',
                    fill: '#FFC72C20',
                },
                {
                    stroke: '#e31837',
                    fill: '#e3183720',
                },
                {
                    stroke: '#808080',
                    fill: '#80808020',
                },
                {
                    stroke: '#00558C',
                    fill: '#00558C20',
                },
                {
                    stroke: '#5F8F3D',
                    fill: '#5F8F3D20',
                },
                {
                    stroke: '#006BD6',
                    fill: '#006BD620',
                },
            ],
        },
        barCharts: {
            fill: '#FFC72C',
            lowestBar: '#FFC72C',
            byPlatformBarChart: { fill: '#FFC72C' },
            byBinBarChart: { fill: '#FFC72C' },
            ertsByRevenueChart: {
                bar1Fill: '#FFC72C',
                bar2Fill: '#e31837',
            },
            averageTimetoFileDispute: { fill: '#e31837' },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: '#e31837',
                lineColor: '#FFC72C',
            },
        },
        heatmapCharts: {
            casesFiled: {
                low: '#e31837',
                mid: '#808080',
                high: '#00558C',
            },
        },
        pieCharts: {
            defaultPieChart: defaultPieChartColors,
            dashboardPieChart: defaultPieChartColors,
            byReasonCodePieChart: defaultPieChartColors,
            byReasonCodeDistributionPieChart: defaultPieChartColors,
            byCardTypePieChart: defaultPieChartColors,
            byLocationTypePieChart: defaultPieChartColors,
            byPlatformPerCardTypePieChart: defaultPieChartColors,
            byStatusPieChart: defaultPieChartColors,
            byWinLossPieChart: defaultPieChartColors,
        },
        radialBarCharts: {
            fill: '#e31837',
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#57a537',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#cb2022`,
        backgroundColor: `rgba(203,32,34,.1)`,
        labelColor: `#cb2022`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#e31837',
        saveAndContinueBtn: {
            margin: '0px',
            fontWeight: 700,
            textTransform: 'capitalize',
            backgroundColor: '#e31837',

            '&:hover': {
                backgroundColor: '#e31837',
            },
        },
        submittingColor: '#3399CC',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '8px 7px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#27272a',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e4e4e7',
    },
    searchBar: {
        padding: '6px',
    },
    select: {
        hover: {
            color: 'inherit',
            backgroundColor: '#F4F4F4',
        },
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#e4e4e7',
                color: '#27272a',
                '&:hover': {
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#263238',
                fontWeight: 500,
                padding: '4px 10px',
                fontSize: '13px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#71717a',
                borderRadius: '4px',
                backgroundColor: '#d4d4d8',
                '&:hover': {
                    color: '#71717a',
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                borderRadius: '4px',
                backgroundColor: '#31B98E',
                '&:hover': {
                    backgroundColor: '#23826F',
                },
            },
        },
        activeStateButton: {
            color: '#FFFFFF',
            backgroundColor: '#52525b',
        },
    },
    icons: {
        uploadIcon: '#3cb4e5',
        dnrAndRevertDnrIcon: '#3cb4e5',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#e31837',
    primaryLight: '#E8465F',
    primary: '#e31837',
    primaryDark: '#9E1026',
    secondaryLight: '#FFD256',
    secondary: '#FFC72C',
    secondaryDark: '#B28B1E',
    secondaryText: "#121315",
    hyperlink: '#00aeef',
    textField: '#e31837',
    switch: '#e31837',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Roboto', 'sans-serif'],
        fontFamilyConfig: {
            primary: 'Roboto',
            fallback:
                '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Arial, sans-serif',
        },
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '16px',
        },
        h6: {
            fontSize: '12px',
        },
        subtitle1: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '12px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '12px',
        },
        body1: {
            fontSize: '13px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '13px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '13px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '13px',
                color: '#52525b',
            },
            tableExpandable: {
                fontSize: '13px',
            },
        },
    },
    shadows: {
        brandShadowLight: 'rgba(9, 167, 209, .4)',
    },
}
